module.exports = __webpack_public_path__ + "static/media/91GsCwayBPL._AC_SL1500_.da12d328.jpg";